import Badge from "ds/components/Badge";
import { BadgeVariant } from "ds/components/Badge/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation, IntentResourceOperationState } from "types/generated";

type IntentProjectHistoryPolicyResult = {
  variant: BadgeVariant;
  label: string;
};

const getPolicyResult = (item: IntentResourceOperation): IntentProjectHistoryPolicyResult => {
  if (item.state === IntentResourceOperationState.PendingReview) {
    return { variant: BadgeVariant.orange, label: "Pending Review" };
  }

  if (item.state === IntentResourceOperationState.Unknown) {
    return { variant: BadgeVariant.gray, label: "Unknown" };
  }

  if (item.deny.length > 0) {
    return { variant: BadgeVariant.red, label: "Denied" };
  }

  return { variant: BadgeVariant.green, label: "Allowed" };
};

const IntentProjectOperationsTablePolicyResultCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const { variant, label } = getPolicyResult(item);

  return (
    <TableSimpleCell {...cellProps}>
      <Badge variant={variant} type="strong" text={label} />
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTablePolicyResultCell;
